
// Services
import { StorageService } from '../services';

// Constants
import { APP_CONFIG } from '../constants';

/**
 * Guarda en el storage la ruta inicial
 * @param {string} path Path inicial
 */
export const savePageInit = (path) => {

    StorageService.save(APP_CONFIG.STORAGE.KEYS.PAGE_INIT, path);
};

/**
 * Obtiene del storage la ruta inicial
 */
export const loadPageInit = () => {

    return StorageService.load(APP_CONFIG.STORAGE.KEYS.PAGE_INIT) || '/';
}

/**
 * Limpia del storage la ruta inicial
 */
export const clearPageInit = () => {

    return StorageService.delete(APP_CONFIG.STORAGE.KEYS.PAGE_INIT);
}

/**
 * Guarda en el storage la versión de la actualización no forzada
 * @param {String} version Flag que indica si el splash ha sido mostrado
 */
export const saveVersion = (version) => {

    StorageService.save(APP_CONFIG.STORAGE.KEYS.VERSION, version);
};

/**
 * Obtiene del storage la versión
 */
export const loadVersion = () => {

    return StorageService.load(APP_CONFIG.STORAGE.KEYS.VERSION) || '';
}

/**
 * Limpia del storage la versión
 */
export const clearVersion = () => {

    StorageService.delete(APP_CONFIG.STORAGE.KEYS.VERSION);
}

/**
 * Guarda en el storage la bandera de mantenimiento
 * @param {Boolean} enabled Flag que indica si se está en mantenimiento o no
 */
export const saveMainteinment = (enabled) => {

    StorageService.save(APP_CONFIG.STORAGE.KEYS.MAINTEINMENT, enabled);
};

/**
 * Obtiene del storage la bandera que indica el último estado de la app guardado
 */
export const loadMainteinment = () => {

    return StorageService.load(APP_CONFIG.STORAGE.KEYS.MAINTEINMENT);
}

/**
 * Limpia del storage la bandera de mantenimiento
 */
export const clearMainteinment = () => {

    StorageService.delete(APP_CONFIG.STORAGE.KEYS.MAINTEINMENT);
}

/**
 * Obtiene del storage el perfil del usuario
 */
export const loadProfile = () => {

    return StorageService.load(APP_CONFIG.STORAGE.KEYS.USER);
}

/**
 * Limpia todo el Storage
 */
export const clearAll = () => {

    StorageService.clear();
}

/**
 * Guarda en el storage la bandera del modal
 * @param {Boolean} show Flag que indica si se abrió el modal
 */
export const saveModal = (show) => {

    StorageService.save(APP_CONFIG.STORAGE.KEYS.MODAL, show);
};

/**
 * Obtiene del storage la bandera que indica el último estado del modal
 */
export const loadModal = () => {

    return StorageService.load(APP_CONFIG.STORAGE.KEYS.MODAL);
}

/**
 * Limpia del storage la bandera del modal
 */
export const clearModal = () => {
    
    StorageService.delete(APP_CONFIG.STORAGE.KEYS.MODAL);
}

/**
 * Obtener valor de Cookie
 */
export const getCookieByKey=(name) =>{
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key === name) return decodeURIComponent(value);
    }
    return null;
}